import { useState, useEffect } from "react";
import NumberPicker from "react-widgets/NumberPicker";
import styled from '@emotion/styled';
import { useTheme } from "@mui/material";

export const NumberPickerWrapperStyled = styled.div`
  .rw-state-focus .rw-widget-picker {
    border-color: ${({ main }) => main};
    box-shadow: 0px 0px 0px 3px rgba(${({ mainRGB }) => mainRGB}, 0.25);
  }
`;

const NumberInput = (props) => {
  const { id, name, type, typeName, order, input: { onChange }, values, required } = props;

  const { palette } = useTheme();
  const { primary: { contrastText, main, mainRGB } } = palette;

  const [value, setValue] = useState();
  const [attribute, setAttribute] =
    useState({
      MIN: 0,
      // MAX: 10,
      STEP: 1
    });

  useEffect(() => {
    let defaultValue;
    const newAttribute = { ...attribute };

    if (values?.length > 0) {
      for (let i = 0; i < values.length; i++) {
        if (!value && values[i].default) {
          defaultValue = values[i]?.value;
        }
        if (values[i].typeName === 'MIN') {
          newAttribute.MIN = values[i].value;
        }
        if (values[i].typeName === 'MAX') {
          newAttribute.MAX = values[i].value;
        }
        if (values[i].typeName === 'STEP') {
          newAttribute.STEP = values[i].value;
        }
      }

      // console.log('!!!!!!!! defaultValue', defaultValue, values)
      setAttribute(newAttribute);
    }

    // If no default value is set then assign min value
    // REMARK: Zero(0) value is NOT NULL VALUE, zero is the same as any other number value
    if (defaultValue == null) {
      // if (!required) {
      //   setValue(newAttribute['MIN']);
      //   onChange(newAttribute['MIN']);
      // }
      // if it has default value then set to store and input field value
    } else {
      setValue(defaultValue);
      // onChange(defaultValue);
      onChange({
        id,
        typeName,
        order,
        result: defaultValue
      });
    }
  }, []);
  // }, [values]);

  const changeHandler = (val) => {
    // console.log('changeHandler', val);
    if (isNaN(val)) {
      return;
    }
    setValue(val);
    // onChange(val);
    if (val == null) {
      onChange(null);
    } else {
      onChange({
        id,
        typeName,
        order,
        result: val
      });
    }

  };

  // return <input type="number"/>
  return (
    <div>
      <NumberPickerWrapperStyled main={main} mainRGB={mainRGB}>
        <NumberPicker
          min={attribute?.['MIN']}
          max={attribute?.['MAX']}
          step={attribute?.['STEP']}
          value={value}
          onChange={changeHandler}
        />
      </NumberPickerWrapperStyled>
    </div>
  )
}
export default NumberInput;